import { Link } from '@one-thd/sui-atomic-components';
import { ArrowBack, ArrowForward } from '@one-thd/sui-icons';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useOrderDetailsContext } from '../../hooks/useContexts';
import { pushOrderDetailsNavButtonEvent } from '../../utils/order-details/analytics';
export var NextPreviousButtons = function () {
    var orderIndex = useOrderDetailsContext().orderIndex;
    var location = useLocation();
    var orderDetailsRoute = location.pathname;
    var _a = useState([]), orderHistoryData = _a[0], setOrderHistoryData = _a[1];
    useEffect(function () {
        var _a;
        var storedOrders = sessionStorage.getItem('orderHistory');
        if (storedOrders) {
            setOrderHistoryData((_a = JSON.parse(storedOrders).orders) !== null && _a !== void 0 ? _a : JSON.parse(storedOrders).lineItems);
        }
    }, [orderIndex]);
    var buildNextPreviousLink = function (direction) {
        var _a, _b, _c, _d;
        if (orderIndex !== undefined) {
            var transactionTypeModifier = function (type) {
                if (type === 'Return')
                    return 'R';
                if (type === 'Sale')
                    return 'S';
                return type;
            };
            if (direction === 'next') {
                if (orderHistoryData && orderHistoryData[orderIndex + 1]) {
                    var nextOrder = orderHistoryData[orderIndex + 1];
                    return "".concat(orderDetailsRoute, "?orderNumber=").concat((_b = (_a = nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.orderNumber, "&salesDate=").concat(nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.salesDate, "&storeNumber=").concat(nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.storeNumber, "&transactionId=").concat(nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.transactionId, "&registerNumber=").concat(nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.registerNumber, "&transactionType=").concat(transactionTypeModifier(nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.transactionType), "&index=").concat(orderIndex + 1);
                }
            }
            if (direction === 'previous') {
                if (orderHistoryData && orderHistoryData[orderIndex - 1]) {
                    var previousOrder = orderHistoryData[orderIndex - 1];
                    return "".concat(orderDetailsRoute, "?orderNumber=").concat((_d = (_c = previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.orderNumbers) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.orderNumber, "&salesDate=").concat(previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.salesDate, "&storeNumber=").concat(previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.storeNumber, "&transactionId=").concat(previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.transactionId, "&registerNumber=").concat(previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.registerNumber, "&transactionType=").concat(transactionTypeModifier(previousOrder === null || previousOrder === void 0 ? void 0 : previousOrder.transactionType), "&index=").concat(orderIndex - 1);
                }
            }
        }
        return '#';
    };
    // previous is newer
    var previousLink = buildNextPreviousLink('previous');
    // next is older
    var nextLink = buildNextPreviousLink('next');
    return (React.createElement(React.Fragment, null, orderHistoryData.length > 0 && orderIndex !== undefined && (React.createElement("div", { className: "\n    sui-flex\n    sui-flex-row\n    sui-items-center\n    sui-justify-self-center\n    sui-gap-16\n    sui-col-span-full\n    sui-order-last\n    sui-mt-11" },
        orderIndex > 0 && (React.createElement(Link, { href: previousLink, underline: "none", onClick: function () {
                pushOrderDetailsNavButtonEvent('previous');
            } },
            React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-row sui-items-center" },
                React.createElement(ArrowBack, { size: "small" }),
                "Previous"))),
        orderIndex < orderHistoryData.length - 1 && (React.createElement(Link, { href: nextLink, underline: "none", onClick: function () {
                pushOrderDetailsNavButtonEvent('next');
            } },
            React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-row sui-items-center" },
                "Next",
                React.createElement(ArrowForward, { size: "small" }))))))));
};
